export default function round(value: any, decimals: any) {
    const num = value + 'e' + decimals
    return Number(Math.round(+num) + 'e-' + decimals);
}
